<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :nombre="nombre"
          :incluirInactivos="incluirInactivos"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Registro de Rubros de Trabajo">
          <b-table hover 
              responsive="sm"
              class="registro" 
              :busy="tableBusy"
              :items="rubros" 
              :fields="rubrosTrabajosFields" 
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(id)="data">
              <strong>{{data.item.id}}</strong>
            </template>
            <template v-slot:cell(pjeMargenMinimo)="data">
              {{ data.item.pjeMargenMinimo | numero(2, true) }}
            </template>
            <template v-slot:cell(pjeMargenMaximo)="data">
              {{ data.item.pjeMargenMaximo | numero(2, true) }}
            </template>
            <template v-slot:cell(premios)="data">
              {{ (data.item.premios) ? 'Si' : 'No' }}
            </template>
            <template v-slot:cell(reembolsos)="data">
              {{ (data.item.reembolsos) ? 'Si' : 'No' }}
            </template>
            <template v-slot:cell(inactivo)="data">
              {{ (data.item.inactivo) ? 'Si' : 'No' }}
            </template>

            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="editar(data.item)">
                  <i class="fa fa-edit"></i>Editar Datos del Rubro</b-dropdown-item>
                <b-dropdown-item @click.stop="borrar(data.item)">
                  <i class="fa fa-remove"></i>Inactivar Rubro</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="agregar">
            <i class="fa fa-plus"></i>Nuevo Rubro</b-dropdown-item>
          <b-dropdown-item @click.stop="exportarXLS">
            <i class="fa fa-file-excel-o"></i>Exportar Listado de Rubros</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Filtro from '../shared/listFiltroNombre.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'rubrostrabajos/getField',
  mutationType: 'rubrostrabajos/updateField',
});

export default {
  name: 'RubrosTrabajos',
  components: {
    appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal,
  ],
  data: () => {
    return {
      rubrosTrabajosFields: [
        {
          key: 'nombre',
          sortable: true
        },
        {
          key: 'pjeMargenMinimo',
          class: 'text-right',
          sortable: true
        },
        { 
          key: 'premios',
          label: 'Diferenciado',
          class: 'text-center', 
        },
        { 
          key: 'reembolsos',
          class: 'text-center', 
        },
        { 
          key: 'inactivo',
          class: 'text-center', 
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center', 
        },
      ],

      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'rubros',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'nombre',
      'incluirInactivos'
    ]),
  },
  created() {
    this.getItems()
  },  
  methods: {
    filtrar(filtro) {
      this.nombre = filtro.nombre;
      this.incluirInactivos = filtro.incluirInactivos;
      this.paginaActual = 1;

      this.getItems();
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('rubrostrabajos/getRubros')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    consultar (item) {
      this.$router.push({ name: 'RubroTrabajosData', 
                          params: { id: item.id }});
    },
    editar (item) {
      this.$router.push({ name: 'RubroTrabajosABM', 
                          params: { id: item.id }});
    },
    borrar (item) {
      this.showModalConfirm('¿Desea inactivar el rubro seleccionado?', 
            this.inactivar.bind(this, item.id), 'Si', null, 'No')
    },
    agregar () {
      this.$router.push({ name: 'RubroTrabajosABM', 
                          params: { id: 0 }});
    },
    inactivar (rubroId) {
      this.$store.dispatch('rubrotrabajo/inactivar', rubroId)
        .then(() => this.showModalMsj('El rubro se inactivó con éxito', this.getItems, this.getItems, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },    
    exportarXLS () {
      this.showSpinner();
      this.$store.dispatch('rubrostrabajos/getRubrosList')
        .then(() => this.exportXLSRubros(this.$store.getters['rubrostrabajos/rubrosList']))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
</style>
